'use client';

import { getBackgroundClass } from '@workspace/lib';
import { cn } from '@workspace/lib';
import { processHeading } from '@workspace/lib/heading-utils';
import { Typography } from '@workspace/ui/common';

import type { ImageTextBlockProps } from './image-text-block.types';
import { renderBody, renderMedia } from './ui';
export function ImageTextBlock({ block }: ImageTextBlockProps) {
  if (!block || typeof block !== 'object') return null;
  const { imagePosition = false, image, header, subHeader, body, backgroundColor, isVideo, video } = block;

  const { text: resolvedHeaderText } = processHeading(header);
  const backgroundClass = getBackgroundClass(backgroundColor);

  return (
    <div className={cn('image-text-block-bg w-full', backgroundClass)}>
      <div className="porta-container">
        <section className="py-12 px-6 md:py-3xl md:px-4xl">
          <div
            className={`flex flex-col md:flex-row items-center ${imagePosition ? 'md:flex-row-reverse' : ''} gap-8 ${
              imagePosition ? 'md:gap-3xl justify-between' : 'md:gap-3xl md:justify-between'
            }`}
          >
            {/* Text Content */}
            <div className="w-full min-w-0">
              <div className="space-y-4">
                <div className="space-y-xs md:space-y-2xs">
                  {resolvedHeaderText && (
                    <Typography
                      variant="h4"
                      className="font-sora! font-semibold! md:font-bold! text-black line-clamp-2 overflow-hidden whitespace-normal break-words text-2xl! !md:text-4xl"
                    >
                      {resolvedHeaderText}
                    </Typography>
                  )}

                  {typeof subHeader === 'string' && subHeader.trim() && (
                    <Typography
                      variant="bodyMd"
                      className="font-sora! font-normal! text-[14px]!  md:font-semibold! md:text-[16px]!  break-words whitespace-normal"
                    >
                      {subHeader}
                    </Typography>
                  )}
                </div>

                <div>{renderBody(body)}</div>
              </div>
            </div>

            {/* Media */}
            <div className={`max-sm:w-full ${imagePosition ? 'md:order-1' : 'md:order-2 '}`}>
              <div
                className={cn(
                  'w-full h-81.75 md:w-136 md:h-136 md:mx-auto flex items-center justify-center',
                  isVideo ? 'bg-transparent' : 'bg-light-silver',
                )}
              >
                {renderMedia({
                  isVideo,
                  video,
                  image,
                  resolvedHeaderText,
                })}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
